import React from 'react';

import useExistingClubRegistration from './UseExistingClubRegistration';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import ClubRegistrationGrid from '../components/grids/clubRegistrationGrid/ClubRegistrationGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const ExistingClubRegistration = () => {
  const {
    location,
    Constants,
    existingClubRegistrationState,
    onRegistrationClicked
  } = useExistingClubRegistration();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={`Existing Club Registration Queue${location.state?.isRevisit === true? ' - Requires Revisit' : ' - New Requests'}`}>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <ClubRegistrationGrid
              data={existingClubRegistrationState.arrayData}
              isLoading={existingClubRegistrationState.isArrayLoading}
              onRegistrationClicked={onRegistrationClicked} />
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={existingClubRegistrationState.isArrayLoading} />
      </WorkFlowNavigation>
    </div>
  );
};

export default ExistingClubRegistration;